<script lang="ts">
	import About from '$lib/components/home/About.svelte';
	import Explore from '$lib/components/home/Explore.svelte';
	import Callout from '$lib/components/home/Callout.svelte';
	import Featured from '$lib/components/home/Featured.svelte';
	// Removed unused imports
	import Private from '$lib/components/home/Private.svelte';
	import Testimonials from '$lib/components/home/Testimonials.svelte';
	import { onMount } from 'svelte';
	import Seo from '$lib/components/SEO.svelte';
	import Welcome from '$lib/components/home/Welcome.svelte';
	import Slideshow from '$lib/components/home/Slideshow.svelte';
	import Winehopper from '$lib/components/home/Winehopper.svelte';
	import InstagramFeed from '$lib/components/home/InstagramFeed.svelte';
	import HeroVideo from '$lib/components/home/HeroVideo.svelte';

	export let data;

	// let animate = false; // Not used
	let showInstagram = false;
	let observer: any;

	onMount(() => {
		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 200);
		// animate = true; // Not used

		// Set up intersection observer for lazy loading Instagram feed
		observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						showInstagram = true;
						observer.disconnect();
					}
				});
			},
			{
				rootMargin: '200px' // Load when within 200px of viewport
			}
		);

		const instagramTrigger = document.getElementById('instagram-trigger');
		if (instagramTrigger) {
			observer.observe(instagramTrigger);
		}
	});

	const tourOperatorScript = `<script type="application/ld+json">${JSON.stringify({
		'@context': 'https://schema.org',
		'@type': 'TourOperator',
		name: 'Tassie Tours',
		url: 'https://tassietours.com',
		telephone: '+61409404337',
		address: {
			'@type': 'PostalAddress',
			streetAddress: '101A Albert Rd',
			addressLocality: 'Moonah',
			addressRegion: 'TAS',
			postalCode: '7009',
			addressCountry: 'AU'
		},
		geo: {
			'@type': 'GeoCoordinates',
			latitude: -42.8462,
			longitude: 147.2836
		},
		openingHoursSpecification: [
			{
				'@type': 'OpeningHoursSpecification',
				dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
				opens: '07:00',
				closes: '19:00'
			}
		],
		image: 'https://tassietours.com/images/hero-carousel-1.jpg',
		logo: {
			'@type': 'ImageObject',
			url: 'https://tassietours.com/favicon.png'
		},
		priceRange: '$$',
		currenciesAccepted: 'AUD'
	})}${'<'}/script>`;
</script>

<svelte:head>
	{@html tourOperatorScript}
</svelte:head>

<Seo
	title="Tasmania Tours - Book Local Tasmanian Tours Today - Tassie Tours"
	description="Day tours from Hobart, Discover Bruny Island, Cradle Mountain, Active Tasmania tours great for backpackers and people looking for adventure. Book today."
	keywords="Tasmania Tours, Tasmania local tour, Tassie Tours, Day tours from Hobart, Discover Bruny Island, Cradle Mountain, Active Tasmania tours"
	siteName="Tassie Tours"
	imageURL="/images/hero-carousel-1.jpg"
	logo="/src/lib/assets/logo/logo-black.png"
	author="Tassie Tours"
	type="website"
	name="Tassie Tours"
	index={true}
	twitter={true}
	openGraph={true}
	schemaOrg={true}
/>
<!-- <Slideshow /> -->
<!-- <Hero /> -->
<HeroVideo />
<Callout />
<Featured />
<Testimonials />
<Welcome />

<Explore />
<About />
<Winehopper />
<!-- <Private /> -->

<div id="instagram-trigger" class="h-1 w-full"></div>
{#if showInstagram}
	<InstagramFeed />
{:else}
	<div class="mx-auto flex max-w-7xl flex-col px-4 py-12 lg:py-24">
		<h2
			class="mt-10 scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
		>
			Connect with us on Instagram
		</h2>
		<div class="flex items-center justify-center py-16">
			<div class="animate-pulse">Loading Instagram feed...</div>
		</div>
	</div>
{/if}
